import { render, staticRenderFns } from "./SensorHistoryEvents.vue?vue&type=template&id=50c395e8&scoped=true&"
import script from "./SensorHistoryEvents.vue?vue&type=script&lang=js&"
export * from "./SensorHistoryEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c395e8",
  null
  
)

export default component.exports